<template>
  <div class="ibox overview-action-box">
    <div class="title" v-if="title">
      <strong>{{title}}</strong>
    </div>
    <div class="content">
      <div class="row">
        <div class="col-md-12">
          <slot/>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.overview-action-box {
  border-radius: $layout-border-radius;
  background-color: #ffffff;
}
.overview-action-box .title {
  border: none;
  border-bottom: 1px solid #f7f7f7;
  color: inherit;
  margin-bottom: 0;
  padding: 15px 90px 8px 15px;
  min-height: 48px;
  position: relative;
  clear: both;
}
.overview-action-box .content {
  clear: both;
  border: none;
  padding: 15px 20px 20px 20px;
}
</style>

<script>
export default {
  name: 'OverviewActionBox',
  props: {
    title: {
      type: String,
      default: 'Actions'
    }
  }
}
</script>